export default __webpack_public_path__ + "static/media/icomoon.49ddcabe.woff";